export default {
      id: "icon_star_passive-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#icon_star_passive-usage",
      toString: function () {
        return this.url;
      }
    }